import React from 'react';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { ADMIN_PERMISSIONS } from '@ApplicationWide/permissions/constants';

const RolePage = React.lazy(() => import('../../../pages/RolePage'));

export default [
  {
    group: ADMIN,
    to: '/administration/new-role/:roleType',
    route: '/administration/new-role/:roleType',
    component: RolePage,
    hasNavBar: true,
    adminVisibilityPermission: ADMIN_PERMISSIONS,
    area: ADMIN_PERMISSIONS,
    requiredRoles: ['admin', 'super_admin'],
  },
  {
    group: ADMIN,
    to: '/administration/edit-role/:roleId',
    route: '/administration/edit-role/:roleId',
    component: RolePage,
    hasNavBar: true,
    adminVisibilityPermission: ADMIN_PERMISSIONS,
    area: ADMIN_PERMISSIONS,
    requiredRoles: ['admin', 'super_admin'],
  },
];
